import { invalidateCache } from 'api/urql/helpers/mutation';

export const bulkDeleteRequestors = (results, args, cache, info) => {
  invalidateCache('paginatedRequestors')(results, args, cache, info);
};
